import React from 'react';

import Boarding from '@rover/icons/svg/boarding.svg';
import Daycare from '@rover/icons/svg/daycare.svg';
import DogTraining from '@rover/icons/svg/dog-training.svg';
import DropIn from '@rover/icons/svg/drop-in.svg';
import Grooming from '@rover/icons/svg/grooming.svg';
import PetInsuranceAlert from '@rover/icons/svg/pet-insurance-alert.svg';
import Sitting from '@rover/icons/svg/sitting.svg';
import Walking from '@rover/icons/svg/walking.svg';
import { Box } from '@rover/kibble/core';
import useTheme from '@rover/kibble/themes/useTheme';

const ICON_SIZE = { width: '25px', height: '25px' };
const CIRCLE_SIZE = { width: '32px', height: '32px' };

const SERVICE_ICON_CONFIG: Record<
  string,
  { Icon: React.ComponentType<{ style?: React.CSSProperties }>; color: string }
> = {
  'dog-boarding': { Icon: Boarding, color: 'blue' },
  'house-sitting': { Icon: Sitting, color: 'blue' },
  'pet-sitting': { Icon: DropIn, color: 'orange' },
  'dog-walking': { Icon: Walking, color: 'orange' },
  'doggy-day-care': { Icon: Daycare, color: 'orange' },
  'dog-training': { Icon: DogTraining, color: 'pink' },
  grooming: { Icon: Grooming, color: 'pink' },
  'pet-insurance': { Icon: PetInsuranceAlert, color: 'pink' },
};

type ServiceIconProps = {
  serviceType: string;
};

const ServiceIcon = ({ serviceType }: ServiceIconProps): JSX.Element | null => {
  const theme = useTheme();
  const config = SERVICE_ICON_CONFIG[serviceType];
  if (!config) return null;

  const { Icon, color } = config;
  return (
    <Box position="relative">
      <Box backgroundColor={theme.colors[color]['200']} borderRadius="round" {...CIRCLE_SIZE} />
      <Box position="absolute" top="4px" left="4px">
        <Icon style={{ ...ICON_SIZE, fill: theme.colors[color]['700'] }} />
      </Box>
    </Box>
  );
};

export default ServiceIcon;
